export function debounce(func, wait, immediate) {
  let timeout
  return function () {
    const context = this,
      args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
export function dayWithMonth(day, locale) {
  return locale === 'en'
    ? `${day
        .toLocaleString(locale, { month: 'long' })
        .capitalize()} ${day.getDate().toString()}th`
    : `${day.getDate().toString()} ${day
        .toLocaleString(locale, { month: 'long' })
        .capitalize()}`
}
